<template>
  <div
    v-if="visible"
    :class="[{ 'loading-overlay': overlay, 'loading-container': containerMode }]"
    :style="containerStyle"
  >
    <div class="loading-content">
      <!-- 旋转圆环 -->
      <div class="loading-spinner">
        <Spinner class="spinner-ring" :style="{ color }" />
      </div>

      <!-- 文本 -->
      <div v-if="text" class="loading-text" :style="{ color }">{{ text }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Spinner from '@rendora/design/assets/spinner.svg?component';
import { computed } from 'vue';

interface Props {
  // 是否容器模式
  containerMode?: boolean;
  // 是否显示
  visible?: boolean;
  // 文本内容
  text?: string;
  // 是否显示遮罩层
  overlay?: boolean;
  // 自定义颜色
  color?: string;
  // 自定义大小
  size?: string | number;
  // 遮罩层背景色
  overlayColor?: string;
  // 是否居中
  center?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  containerMode: false,
  visible: true,
  overlay: false,
  color: '#ffffff',
  size: '20px',
  overlayColor: 'rgba(0, 0, 0, 0.5)',
  center: true,
});

const size = computed(() => {
  return typeof props.size === 'number' ? `${props.size}px` : props.size;
});

const containerStyle = computed(() => {
  const style: Record<string, string> = {};

  if (props.overlay) {
    style.backgroundColor = props.overlayColor;
  }

  if (props.center) {
    style.display = 'flex';
    style.alignItems = 'center';
    style.justifyContent = 'center';
  }

  return style;
});
</script>

<style scoped>
.loading-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 40px;
}

.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.loading-spinner {
  width: v-bind(size);
  height: v-bind(size);
  position: relative;
}

.spinner-ring {
  width: 100%;
  height: 100%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  margin-top: 6px;
}
</style>
